import { render, staticRenderFns } from "./ReactionItem.vue?vue&type=template&id=10155a4e&scoped=true"
import script from "./ReactionItem.vue?vue&type=script&lang=js"
export * from "./ReactionItem.vue?vue&type=script&lang=js"
import style0 from "./ReactionItem.vue?vue&type=style&index=0&id=10155a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10155a4e",
  null
  
)

export default component.exports